<template>
    <div>
      <div class="modal hide fade" id="modalRequestEdit" tabindex="-1" role="dialog" aria-labelledby="modalRequestEdit" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                  <div class="modal-header red darken-3 text-left text-white">
                      <h4 class="modal-title w-100 font-weight-bold">Request Edit</h4>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                      <form>
                          <div class="form-group">
                              <label for="request_edit" class="col-form-label">Request:</label>
                              (max: <span v-text="(max - request_edit.length)" style="color: blue;"></span>)
                              <textarea v-model="request_edit" class="form-control" rows="5" :maxlength="max"/>
                          </div>
                      </form>
                  </div>
                  <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                  <button type="button" class="btn btn-primary" data-dismiss="modal" @click="requestEdit">Process</button>
                  </div>
              </div>
          </div>
      </div>
      <div class="modal hide fade" id="modalRequestEditPurchasing" tabindex="-1" role="dialog" aria-labelledby="modalRequestEdit" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                  <div class="modal-header red darken-3 text-left text-white">
                      <h4 class="modal-title w-100 font-weight-bold">Request Edit</h4>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                      <form>
                          <div class="form-group">
                              <label for="request_edit" class="col-form-label">Request:</label>
                              (max: <span v-text="(max - request_edit.length)" style="color: blue;"></span>)
                              <textarea v-model="request_edit" class="form-control" rows="5" :maxlength="max"/>
                          </div>
                      </form>
                  </div>
                  <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                  <button type="button" class="btn btn-primary" data-dismiss="modal" @click="requestEditPurchasing">Process</button>
                  </div>
              </div>
          </div>
      </div>
      <div class="modal hide fade" id="modalRequestVoid" tabindex="-1" role="dialog" aria-labelledby="modalRequestVoid" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                  <div class="modal-header red darken-3 text-left text-white">
                      <h4 class="modal-title w-100 font-weight-bold">Request Void</h4>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                      <form>
                            <div class="form-group">
                                <label for="request_edit" class="col-form-label">Request: </label>
                                (max: <span v-text="(max - request_void.length)" style="color: blue;"></span>)
                                <textarea v-model="request_void" class="form-control" rows="5" :maxlength="max"/>
                            </div>
                      </form>
                  </div>
                  <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                  <button type="button" class="btn btn-primary" data-dismiss="modal" @click="requestVoid">Process</button>
                  </div>
              </div>
          </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'PurchasingRequestModal',
  data () {
    return {
      max: 100,
      request_edit: '',
      request_void: ''
    }
  },
  methods: {
    requestEdit: function () {
      this.$emit('getRequestEdit', this.request_edit)
    },
    requestVoid: function () {
      this.$emit('getRequestVoid', this.request_void)
    },
    requestEditPurchasing () {
      this.$emit('getRequestEdit', this.request_edit)
    }
  }
}
</script>
